import { isPlatformBrowser } from '@angular/common';
import {
  IPublicClientApplication,
  PublicClientApplication,
} from '@azure/msal-browser';

import { getMsalConfig } from './msal.config';

function createServerSideMock(): IPublicClientApplication {
  const noopPromise = <T>(value: T = null as T) => Promise.resolve(value);
  const noop = (): void => {
    /* no-op for SSR */
  };

  return {
    initialize: () => noopPromise(),
    acquireTokenPopup: () => noopPromise(null),
    acquireTokenRedirect: () => noopPromise(),
    acquireTokenSilent: () => noopPromise(null),
    acquireTokenByCode: () => noopPromise(null),
    addEventCallback: () => null,
    removeEventCallback: noop,
    addPerformanceCallback: () => '',
    removePerformanceCallback: () => false,
    enableAccountStorageEvents: noop,
    disableAccountStorageEvents: noop,
    getAccount: () => null,
    getAccountByHomeId: () => null,
    getAccountByLocalId: () => null,
    getAccountByUsername: () => null,
    getAllAccounts: () => [],
    handleRedirectPromise: () => noopPromise(null),
    loginPopup: () => noopPromise(null),
    loginRedirect: () => noopPromise(),
    logout: () => noopPromise(),
    logoutRedirect: () => noopPromise(),
    logoutPopup: () => noopPromise(),
    ssoSilent: () => noopPromise(null),
    getTokenCache: () => ({}) as unknown as ReturnType<IPublicClientApplication['getTokenCache']>,
    getLogger: () => ({}) as unknown as ReturnType<IPublicClientApplication['getLogger']>,
    setLogger: noop,
    setActiveAccount: noop,
    getActiveAccount: () => null,
    initializeWrapperLibrary: noop,
    setNavigationClient: noop,
    getConfiguration: () => ({}) as unknown as ReturnType<IPublicClientApplication['getConfiguration']>,
    hydrateCache: () => noopPromise(null),
    clearCache: () => noopPromise(),
  } as unknown as IPublicClientApplication;
}

export function msalInstanceFactory(platformId: object): IPublicClientApplication {
  if (isPlatformBrowser(platformId)) {
    return new PublicClientApplication(getMsalConfig());
  }
  return createServerSideMock();
}
